export const hoursMinutesFields = [
  'customerReminder.barber_reminder.time',
  'customerReminder.reminder.time',
  'notifications.reminder.time',
  'advanceBookMins',
  'advanceCancelMins',
];
